export const checkSearchValueForObjectName = (
  name: string,
  searchValue: string
): boolean => {
  const loweredNameParts = name.toLowerCase().split(" ");
  const loweredSearchValue = searchValue.toLowerCase();

  return loweredNameParts.some((loweredNamePart) =>
    loweredNamePart.startsWith(loweredSearchValue)
  );
};
